import React from 'react';
import PropTypes from 'prop-types';
import {alpha, useTheme} from '@mui/material/styles';

/**
 * Circular flag badge with optional selection ring and check overlay.
 */
const FlagBadge = ({src, size = 56, selected = false, ringW = 2}) => {
  const theme = useTheme();
  const ringColor = selected ? theme.palette.primary.main : 'transparent';

  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `${ringW}px solid ${ringColor}`,
        background: selected ? theme.palette.primary.lighter : theme.palette.action.selected,
        overflow: 'hidden',
        flexShrink: 0,
        transition: 'border-color 180ms cubic-bezier(0.16,1,0.3,1), background 180ms cubic-bezier(0.16,1,0.3,1)',
      }}
      aria-hidden='true'
    >
      <img
        src={src}
        alt=''
        style={{width: '72%', height: '72%', objectFit: 'contain'}}
      />
    </span>
  );
};

/**
 * Small check badge overlaid on a selected flag.
 */
const CheckBadge = ({size = 20}) => {
  const theme = useTheme();
  return <span
    style={{
      position: 'absolute',
      top: -3,
      insetInlineEnd: -3,
      width: size,
      height: size,
      borderRadius: '50%',
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: `2px solid ${theme.palette.background.paper}`,
      boxShadow: `0 2px 6px ${alpha(theme.palette.primary.main, 0.4)}`,
    }}
  >
    <svg
      width={Math.round(size * 0.62)} height={Math.round(size * 0.62)}
      viewBox='0 0 24 24' fill='none' stroke='currentColor'
      strokeWidth={3} strokeLinecap='round' strokeLinejoin='round'
    >
      <path d='M20 6 9 17l-5-5' />
    </svg>
  </span>;
};

CheckBadge.propTypes = {
  size: PropTypes.number,
};

FlagBadge.propTypes = {
  ringW: PropTypes.number,
  selected: PropTypes.bool,
  size: PropTypes.number,
  src: PropTypes.string.isRequired,
};

export {CheckBadge};
export default FlagBadge;
